import React from 'react'
import Text from '../../Landing/ui/Text'

type FloatingHeadlineProps = {
  /** The headline text rendered next to the line */
  text: string
  /** Optional class for the wrapper */
  className?: string
  /** Optional element type for the headline (default: 'h2') */
  as?: 'h1' | 'h2' | 'h3'
}

function FloatingHeadline({ text, className = '', as: Tag = 'h2' }: FloatingHeadlineProps) {
  return (
    <div className={`relative ml-8 md:ml-20 ${className}`}>
      <div
        className="h-px w-screen bg-blue absolute top-1/2 right-full -translate-y-1/2"
        aria-hidden
      />
      <Text text={text} semibold size="xlarge" className="ml-3" />
    </div>
  )
}

export default FloatingHeadline
